import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { User } from "../../../constants/types";

export type UserState = {
  users: User[];
};

const initialState: UserState = {
  users: [],
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    addUser(state, action: PayloadAction<User>) {
      state.users.unshift(action.payload);
    },
    removeUser(state, action: PayloadAction<string>) {
      state.users = state.users.filter((user) => user.id !== action.payload);
    },
    resetUsers(state) {
      state.users = [];
    },
    setUsers(state, action: PayloadAction<User[]>) {
      state.users = action.payload;
    },
    setUsersByRole(
      state,
      action: PayloadAction<{ users: User[]; role: string }>
    ) {
      state.users = state.users.filter(
        (user) => user.role !== action.payload.role
      );
      state.users.push(...action.payload.users);
    },
  },
});

export const { addUser, removeUser, resetUsers, setUsers, setUsersByRole } =
  userSlice.actions;

export default userSlice.reducer;
